import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import { Link, useLocation } from "react-router-dom";

export default function CustomButtonsRedirectGroupFarms() {
    const { t } = useTranslation();
    const location = useLocation();

    const currentPath = location.pathname;

    return (
        <div>
            <div className="container-fluid mt-4">
                <div className="col-sm-12 col-md-12 col-lg-11 mx-auto">
                    <ButtonGroup>
                        <Link to="/DetailsGroupFarms/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/DetailsGroupFarms/'}
                            >
                                {t("Global_Label_Text_Details")}
                            </Button>
                        </Link>
                        <Link to="/InformationGroupFarms/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/InformationGroupFarms/'}
                            >
                                {t("Global_Label_Text_Information")}
                            </Button>
                        </Link>
                        <Link to="/MovementsGroupFarms/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/MovementsGroupFarms/'}
                            >
                                {t("Global_Label_Text_Movements")}
                            </Button>
                        </Link>
                        <Link to="/GroupSequencesGroupFarms/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/GroupSequencesGroupFarms/'}
                            >
                                {t("Global_Label_Text_Group_Sequences")}
                            </Button>
                        </Link>
                        <Link to="/PowerCurveGroupFarms/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/PowerCurveGroupFarms/'}
                            >
                                {t("Global_Label_Text_Power_Curve")}
                            </Button>
                        </Link>
                    </ButtonGroup>
                </div>
            </div>
        </div>
    );
}